const NAME = "TRANSACTION_LOG";

export default NAME;
